import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTruck, FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Try to load logo image, fallback to icon if not found
  const logoJpgPath = '/images/logo.jpg';
  const logoPngPath = '/images/logo.png';
  const logoSvgPath = '/images/logo.svg';
  const [logoSrc, setLogoSrc] = useState(null);

  useEffect(() => {
    // Check which logo format exists (check JPG first since it's the current format)
    const imgJpg = new Image();
    imgJpg.onload = () => setLogoSrc(logoJpgPath);
    imgJpg.onerror = () => {
      const imgPng = new Image();
      imgPng.onload = () => setLogoSrc(logoPngPath);
      imgPng.onerror = () => {
        const imgSvg = new Image();
        imgSvg.onload = () => setLogoSrc(logoSvgPath);
        imgSvg.onerror = () => setLogoSrc(null);
        imgSvg.src = logoSvgPath;
      };
      imgPng.src = logoPngPath;
    };
    imgJpg.src = logoJpgPath;
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-wrapper">
          <Link to="/" className="logo">
            {logoSrc ? (
              <img src={logoSrc} alt="V&R Courier Ltd Logo" className="logo-img" />
            ) : (
              <FaTruck className="logo-icon" />
            )}
            <span>V&R Courier Ltd</span>
          </Link>

          <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
            <li>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/services" className={location.pathname === '/services' ? 'active' : ''}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
                About
              </Link>
            </li>
            <li>
              <Link to="/track" className={location.pathname === '/track' ? 'active' : ''}>
                Track Shipment
              </Link>
            </li>
            <li>
              <Link to="/careers" className={location.pathname === '/careers' ? 'active' : ''}>
                Careers
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>
                Contact
              </Link>
            </li>
            <li className="nav-cta">
              <Link to="/quote" className="btn btn-primary">
                Get Quote
              </Link>
            </li>
          </ul>

          <div className="hamburger" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

